import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../firebase';
import StateContext from '../../StateContext';

function RemoveFollow({userId, followObj, setIsFollowing, userFollowCollectionId, followers}) {

    const appState = useContext(StateContext)
    const [message, setMessage] = useState("")

    const [followDocToDelete, setFollowDocToDelete] = useState()

    useEffect(() => {
        console.log(followers, "FOLLOWERS")
        try {
            const userFollowCollection = firestore.collection("authors").doc(appState.userData.authorId).collection("following");
            userFollowCollection.onSnapshot(({docs}) => {
                const following = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                if (following.length) {
                    const followedDocToRemove = following.filter(user => user.authorId === userId)
                    console.log(followedDocToRemove, "FOLLOWED DOC TO REMOVE")
                }
            })
        } catch (error) {
            
        }

    }, [])



    async function removeFollowHandler(e) {
        e.preventDefault();
        const filteredFollowersArray = followers.filter(follower => {
            return follower.follower_id === appState.userId
        })
        console.log(filteredFollowersArray)
        if (filteredFollowersArray.length > 0) {
            try {
                const followRef = firestore.collection("follow").doc(filteredFollowersArray[0].id);
                followRef.delete()
                setMessage("Sluttet å følge")
                setIsFollowing(false)
                console.log("Sluttet å følge")
            } catch (error) {
                setIsFollowing(true)
                setMessage("Noe gikk galt")
                console.log(error)
            }
        }


    }

    return (

        <form onSubmit={removeFollowHandler}>
            {message && <div>{message}</div>}
            <button className="follow-button"><i className="fas fa-user"></i> <i className="fas fa-check"></i></button>
        </form>

    )
}
export default RemoveFollow